// Onboarding Screen - Full-Width Responsive Layout
import { useState } from 'react';
import { useApp } from '../hooks/useApp';
import { SCREENS } from '../config/constants';
import { storage } from '../services/storage';
import { Container, Text, Button } from '../components/ui';
import Icons from '../components/Icons';

const slides = [
    { title: 'Chào mừng bạn', desc: 'Ứng dụng phân tích sức khỏe dựa trên Y học Cổ truyền kết hợp AI', emoji: '👋' },
    { title: 'Thiệt Chẩn (舌診)', desc: 'Phân tích màu sắc, hình dạng, rêu lưỡi để đánh giá tình trạng sức khỏe', emoji: '👅' },
    { title: 'Diện Chẩn (面診)', desc: 'Nhận diện các dấu hiệu sức khỏe qua sắc mặt và vùng phản xạ', emoji: '😊' },
    { title: 'Theo dõi liên tục', desc: 'Thiết lập Baseline cá nhân và theo dõi xu hướng sức khỏe theo thời gian', emoji: '📈' },
];

function OnboardingScreen() {
    const { setCurrentScreen } = useApp();
    const [step, setStep] = useState(0);

    const completeOnboarding = () => {
        storage.setOnboarded();
        setCurrentScreen(SCREENS.HOME);
    };

    return (
        <Container className="min-h-screen flex flex-col bg-theme-bg" safe>
            {/* Skip button */}
            <div className="main-content flex justify-end pt-4">
                <button onClick={completeOnboarding} className="text-theme-secondary text-sm touch-target">
                    Bỏ qua
                </button>
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col items-center justify-center text-center">
                <div className="main-content">
                    <div className="text-7xl mb-8">{slides[step].emoji}</div>
                    <Text variant="h2" className="mb-4">{slides[step].title}</Text>
                    <Text variant="caption" className="max-w-xs leading-relaxed">{slides[step].desc}</Text>
                </div>

                {/* Pagination dots */}
                <div className="flex justify-center gap-2 mb-6">
                    {slides.map((_, idx) => (
                        <div
                            key={idx}
                            className={`w-2 h-2 rounded-full transition-all ${idx === step ? 'bg-primary w-6' : 'bg-theme-tertiary'
                                }`}
                        />
                    ))}
                </div>

                {/* Buttons */}
                <div className="main-content pb-8">
                    <Button
                        onClick={() => step < slides.length - 1 ? setStep(step + 1) : completeOnboarding()}
                        className="w-full mb-3"
                        rightIcon={<Icons.ChevronRight />}
                    >
                        {step < slides.length - 1 ? 'Tiếp tục' : 'Bắt đầu'}
                    </Button>
                    {step > 0 && (
                        <Button
                            variant="ghost"
                            onClick={() => setStep(step - 1)}
                            className="w-full"
                        >
                            Quay lại
                        </Button>
                    )}
                </div>
            </div>
        </Container>
    );
}

export default OnboardingScreen;
